var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import CompanyStore from 'stores/CompanyStore/store';
import FormStateStore from 'stores/FormStateStore/store';
import ClientStateStore from 'stores/ClientStateStore/store';
import { submitScoreForm } from 'actions/ScoreActionCreators';
import { setFormToInactive } from 'actions/ServerActionCreators';
import { setClientKey } from 'actions/ClientActionCreators';
import { FormStateSchema } from 'types/formState';
import UniqueId from 'utils/UniqueId';
function getStateFromStores(formId) {
    return __assign(__assign({}, CompanyStore.getCompanyInfo()), { formState: FormStateStore.getFormState(formId) });
}
var Score = /** @class */ (function (_super) {
    __extends(Score, _super);
    function Score(props) {
        var _this = _super.call(this, props) || this;
        _this.persistKey = 'score_data';
        _this.UniqueId = UniqueId();
        _this.state = __assign(__assign({}, getStateFromStores(_this.UniqueId)), { productCountMap: {}, memo: '', memo_error: false });
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.handleValueBlur = _this.handleValueBlur.bind(_this);
        _this.handleValueFocus = _this.handleValueFocus.bind(_this);
        _this.changeMemo = _this.changeMemo.bind(_this);
        _this.submit = _this.submit.bind(_this);
        return _this;
    }
    Score.prototype.componentDidMount = function () {
        CompanyStore.addChangeListener(this.onChangeHandler);
        FormStateStore.addChangeListener(this.onChangeHandler);
        this.loadSavedValues();
    };
    Score.prototype.componentWillUnmount = function () {
        CompanyStore.removeChangeListener(this.onChangeHandler);
        FormStateStore.removeChangeListener(this.onChangeHandler);
        this.persistValues();
    };
    Score.prototype.handleValueFocus = function (event) {
        var element = event.target;
        if (parseInt(element.value, 10) === 0) {
            element.value = '';
        }
        else {
            setTimeout(function () { return element.setSelectionRange(100, 100); }, 1000);
        }
    };
    Score.prototype.handleValueBlur = function (event) {
        var target = event.target;
        target.value = String(parseInt(target.value, 10) || 0);
    };
    Score.prototype.onChangeHandler = function () {
        var nextState = getStateFromStores(this.UniqueId);
        // If form state is being set to success
        if (nextState.formState &&
            nextState.formState.state === FormStateSchema.Enum.SUCCESS) {
            // And, it wasn't already success
            if (this.state.formState.state !== FormStateSchema.Enum.SUCCESS) {
                // Set local success
                this.clearData();
            }
        }
        this.setState(nextState);
    };
    Score.prototype.getProducts = function () {
        var _this = this;
        return this.state.products.map(function (product) {
            var name = product.product_name;
            var style = classNames({
                'scorecard-trackable-input-container': true,
                'scorecard-trackable-input--value': product.value_required
            });
            return (_jsxs("div", { className: "scorecard-trackable", children: [_jsx("span", { className: "scorecard-trackable-name", children: _jsx("span", { children: name }) }), _jsxs("div", { className: style, children: [_jsx("input", { type: "text", pattern: "[0-9]*", value: _this.state.productCountMap[product.id] || 0, onChange: function (event) { return _this.changeValue(product.id, event); }, onFocus: _this.handleValueFocus, onBlur: _this.handleValueBlur }), _jsx("button", { className: "scorecard-increment", onClick: function () { return _this.increment(product.id); }, "aria-label": "Increment", children: _jsx("i", { className: "ion-plus" }) }), _jsx("button", { className: "scorecard-decrement", onClick: function () { return _this.decrement(product.id); }, "aria-label": "Decrement", children: _jsx("i", { className: "ion-minus" }) })] })] }, product.id));
        });
    };
    Score.prototype.getScoreButton = function () {
        var loading = this.state.formState.state === FormStateSchema.Enum.LOADING;
        var success = this.state.formState.state === FormStateSchema.Enum.SUCCESS;
        var scoreClasses = classNames({
            'submit-score': true,
            'button--main': !success,
            'button--success': success,
            'button--is-loading': loading
        });
        var iconClasses = classNames({
            'icon--md': true,
            'ion-checkmark-circled': !loading,
            'ion-load-c': loading
        });
        var message = ' Send to scoreboard';
        if (success) {
            message = ' Success!';
        }
        else if (loading) {
            message = ' Sending';
        }
        return (_jsxs("button", { onClick: this.submit, className: scoreClasses, children: [_jsx("i", { className: iconClasses }), ' ', message] }));
    };
    Score.prototype.getMemoSection = function () {
        var memoStyle = classNames({
            'scorecard-memo': true,
            'form-error': this.state.memo_error
        });
        if (this.state.account.disable_memo) {
            return _jsx("p", { children: "\u00A0" });
        }
        return (_jsxs("div", { className: "scorecard-memo-container", children: [_jsx("textarea", { onChange: this.changeMemo, value: this.state.memo, name: "", id: "", cols: 30, rows: 10, className: memoStyle, placeholder: "Add a memo\u2026" }), _jsx("small", { children: "Not intended for Personally Identifiable Information (PII)" })] }));
    };
    Score.prototype.buildProductCountMap = function () {
        return this.state.products.reduce(function (acc, product) {
            acc[product.id] = 0;
            return acc;
        }, {});
    };
    Score.prototype.loadSavedValues = function () {
        var data = ClientStateStore.getClientKey(this.persistKey);
        var updatedState = {
            productCountMap: this.buildProductCountMap(),
            memo: ''
        };
        if (data && data.products) {
            updatedState.productCountMap = data.products;
        }
        if (!this.state.account.disable_memo &&
            data &&
            data.memo &&
            data.memo.length) {
            updatedState.memo = data.memo;
        }
        this.setState(updatedState);
    };
    Score.prototype.persistValues = function () {
        var data = {
            products: this.state.productCountMap,
            memo: this.state.account.disable_memo ? '' : this.state.memo
        };
        setClientKey(this.persistKey, data);
    };
    Score.prototype.increment = function (productId) {
        this.setState(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), { productCountMap: __assign(__assign({}, prevState.productCountMap), (_a = {}, _a[productId] = prevState.productCountMap[productId] + 1, _a)) });
        });
        this.clearSuccess();
    };
    Score.prototype.decrement = function (productId) {
        this.setState(function (prevState) {
            var _a;
            var currentValue = prevState.productCountMap[productId];
            if (currentValue <= 0) {
                return prevState;
            }
            return __assign(__assign({}, prevState), { productCountMap: __assign(__assign({}, prevState.productCountMap), (_a = {}, _a[productId] = prevState.productCountMap[productId] - 1, _a)) });
        });
        this.clearSuccess();
    };
    Score.prototype.changeValue = function (productId, event) {
        var target = event.target;
        var value = parseInt(target.value, 10);
        if (!Number.isFinite(value)) {
            value = 0;
        }
        this.setState(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), { productCountMap: __assign(__assign({}, prevState.productCountMap), (_a = {}, _a[productId] = value, _a)) });
        });
        this.clearSuccess();
    };
    Score.prototype.changeMemo = function (event) {
        this.setState(function (prevState) {
            return __assign(__assign({}, prevState), { memo: event.target.value, memo_error: prevState.memo_error ?
                    event.target.value.length <= 0 :
                    false });
        });
        this.clearSuccess();
    };
    Score.prototype.clearSuccess = function () {
        if (this.state.formState.state !== FormStateSchema.Enum.INACTIVE) {
            setFormToInactive(this.UniqueId);
        }
    };
    Score.prototype.clearData = function () {
        this.setState({
            productCountMap: this.buildProductCountMap(),
            memo: ''
        });
    };
    Score.prototype.submit = function () {
        var _this = this;
        if (this.state.formState.state === FormStateSchema.Enum.LOADING) {
            return;
        }
        var data = [];
        var memoRequired = false;
        var memo = !this.state.account.disable_memo ? this.state.memo : '';
        _.each(this.state.products, function (product) {
            var storedalue = _this.state.productCountMap[product.id] || 0;
            var currentUser = _this.state.users.find(function (u) { return u.id === _this.state.current_user.id; });
            var quantity;
            var value;
            if (storedalue <= 0) {
                return;
            }
            if (!_this.state.account.disable_memo && product.memo_required) {
                memoRequired = true;
            }
            if (product.value_required) {
                value = parseInt(String(storedalue), 10);
                quantity = 1;
            }
            else {
                value = 0;
                quantity = parseInt(String(storedalue), 10);
            }
            if (!currentUser) {
                return;
            }
            data.push({
                user_email: currentUser.email,
                product_name: product.product_name,
                trackable_id: product.id,
                quantity: quantity,
                value: value,
                memo: memo
            });
        });
        if (!_.isEmpty(data)) {
            if (memoRequired && !memo.length) {
                this.setState({ memo_error: true });
            }
            else {
                // Prevent button mashing
                this.setState({
                    formState: {
                        state: FormStateSchema.Enum.LOADING,
                        message: ''
                    }
                });
                submitScoreForm(data, this.UniqueId);
            }
        }
    };
    Score.prototype.render = function () {
        return (_jsxs("div", { className: "sb-app-main", children: [_jsx("h1", { className: "activity-heading", children: "Scorecard" }), _jsxs("div", { className: "sb-app-scorecard", children: [_jsx("div", { className: "scorecard-trackables", children: this.getProducts() }), this.getMemoSection(), this.getScoreButton()] })] }));
    };
    return Score;
}(React.Component));
export default Score;
